import styled from 'styled-components'

export const DraftsLimitContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`

export const DraftsLimitWindow = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  width: 530px;
  height: 730px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const Title = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #000000;
`

export const DraftsImage = styled.img`
  width: auto;
  height: 284px;
  margin-top: 52px;
`

export const DraftsDescription = styled.p`
  font-weight: 700;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  color: #000000;
  margin-top: 52px;
  margin-bottom: 52px;

  & span {
    color: #ff5e6d;
  }
`

export const SubscribeButton = styled.button`
  background: #ff5e6d;
  border-radius: 22px;
  width: 280px;
  height: 44px;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  position: relative;
  border: none;
  cursor: pointer;

  & span {
    margin-right: -20px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const MembershipCircle = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5px;
  left: 6px;

  & img {
    height: 26px;
  }
`

export const CloseModal = styled.img`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`
